import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { TextureBackground } from 'atoms/ui/TextureBackground';
import { tabletAndAbove } from 'style/mediaQuery';
import { HexColor } from 'style/types';

import sideSvg from './assets/side.svg';

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  height: 100%;
  background: var(--background);

  @media ${tabletAndAbove} {
    grid-template-columns: calc(5 * var(--unit)) 1fr calc(5 * var(--unit));
  }
`;

const SideColor = styled.div`
  display: none;

  @media ${tabletAndAbove} {
    display: block;
    position: relative;
    isolation: isolate;
    width: calc(5 * var(--unit));
    height: 100%;
    background: var(--text-background-color);
  }
`;

const SideText = styled.div`
  position: absolute;
  top: 0;
  left: var(--intermediate-unit);
  width: var(--double-unit);
  height: 100%;
  color: var(--text-color);
  background: url(${sideSvg}) repeat-y center / contain;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
`;

const TextureBackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  z-index: -1;
  & > * {
    width: 100%;
    height: 100%;
  }
  &:after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(var(--c-rgb-black), 0.4) 80%,
      rgba(var(--c-rgb-black), 1) 100%
    );
  }
`;

type Props = {
  children: ReactNode;
  color: HexColor;
  textColor: HexColor;
  background?: string;
  hideTextureBackground?: boolean;
};
export const Season26TutorialBackground = ({
  children,
  color,
  textColor,
  background,
  hideTextureBackground = false,
}: Props) => {
  return (
    <Root
      style={
        {
          '--text-background-color': color,
          '--text-color': textColor,
          '--background': background,
        } as CSSProperties
      }
    >
      <SideColor style={{ left: 0 } as CSSProperties}>
        <SideText />
      </SideColor>
      <Content>
        {!hideTextureBackground && (
          <TextureBackgroundWrapper>
            <TextureBackground background="wave1" mode="light" color={color} />
          </TextureBackgroundWrapper>
        )}
        {children}
      </Content>
      <SideColor style={{ right: 0 } as CSSProperties}>
        <SideText />
      </SideColor>
    </Root>
  );
};
